import { graphql } from "gatsby"
import React from "react"

import LinkList from "@molecules/LinkList/LinkList"

const LinkListBlock = ({ blockDataLinkList }) => {
  const { heading, links } = blockDataLinkList || {}
  const linksFormatted = Array.isArray(links)
    ? links.map((item) => {
        return item.link
      })
    : []
  return <LinkList heading={heading} list={linksFormatted} />
}

export const query = graphql`
  fragment LinkList on WpBlockAcfLinkList {
    __typename
    blockDataLinkList {
      heading
      headingsize
      links {
        link {
          target
          title
          url
        }
      }
    }
  }
`

export default LinkListBlock
